import { useEffect, useState } from "react";
import Select from 'react-select';
import {
  Typography,
  Popover,
  PopoverHandler,
  PopoverContent,
  Button
} from "@material-tailwind/react";
import _, { get } from "lodash";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import useWindowWidth from "utills/InitWidthDevice";
import { useTranslation } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import ApiService from "utills/ApiService";
import { ArrowDownIcon, EyeIcon, PencilIcon, SearchIcon } from "@heroicons/react/outline";
import DateRangePicker from "components/wps/DateRangePicker";
import { FullScreenLoading } from "components/fullScreenLoading";
import Pagination from "components/wps/Pagination";
import toast from "react-hot-toast";
import NewButton from "components/button";
import { isHaveActionPermission } from "utills/helpers";

const OrdersForm = (props: any) => {
  const { translate, isMobile, language } = props;
  const [openFilter, setOpenFilter] = useState(false);
  const [applyDate, setApplyDate] = useState({
    start: '',
    end: ''
  });
  const [purchasedDate, setPurchasedDate] = useState({
    start: '',
    end: ''
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [orderList, setOrderList] = useState([] as any);
  const [paging, setPaging] = useState(null as any);
  const [filter, setFilter] = useState(true);
  const [filterGroup, setFilterGroup] = useState({
    q: '',
    payment_method: '',
    order_status: '',
    order_type: '',
    event_id: '',
    is_vat: '',
    ticket_platform: '',
    is_private_flow: ''
  });
  const [eventList, setEventList] = useState([] as any);
  const [orderType, setOrderType] = useState([] as any);
  const [fetchData, setFetchData] = useState(false);
  const [accountType, setAccountType] = useState('all');
  const [openExportGroup, setOpenExportGroup] = useState(false);
  const [showPlatform, setShowPlatform] = useState(false);

  const order_status = [
    {
      value: '',
      label: translate('all-status')
    },
    {
      value: 'doi_thanh_toan',
      label: translate('order-pending')
    },
    {
      value: 'dat_hang_thanh_cong',
      label: translate('order-success')
    },
    {
      value: 'hoan_tien',
      label: translate('order-refund')
    },
    {
      value: 'da_huy',
      label: translate('order-canceled')
    },
  ] as any;

  const payment_method = [
    {
      value: '',
      label: translate('all')
    },
    {
      value: 'atm',
      label: translate('atm')
    },
    {
      value: 'bank_transfer',
      label: translate('bank-transfer')
    },
    {
      value: 'credit',
      label: translate('credit')
    },
    {
      value: 'partner_vnpay',
      label: 'Partner VNPay'
    },
    {
      value: 'vn_pay_b',
      label: 'VNPAY'
    },
    {
      value: 'vnpay',
      label: 'QR Code'
    },
    {
      value: 'zalopay',
      label: 'ZaloPay'
    },
    {
      value: 'viet_qr',
      label: 'Viet QR'
    },
    {
      value: 'momo',
      label: translate('momo')
    },
    {
      value: 'voucher',
      label: translate('coupon')
    },
    {
      value: 'shipcode',
      label: 'Ship Code'
    },
    {
      value: 'free',
      label: translate('free-ticket')
    },
    {
      value: 'bnpl',
      label: translate('bnpl')
    },
    {
      value: 'viettel_money',
      label: translate('viettel_money')
    },
    {
      value: 'v_atm',
      label: translate('v_atm')
    },
    {
      value: 'v_credit',
      label: translate('v_credit')
    },
    {
      value: 'payoo_atm',
      label: translate('payoo_atm')
    },
    {
      value: 'payoo_credit',
      label: translate('payoo_credit')
    },
    {
      value: 'onepay_viet_qr',
      label: translate('onepay_viet_qr')
    },
    {
      value: 'stripe',
      label: translate('stripe-payment')
    },
  ] as any;

  const vat_option = [
    {
      value: '',
      label: translate('all')
    },
    {
      value: "0",
      label: translate('not')
    },
    {
      value: "1",
      label: translate('yes')
    }
  ] as any;

  const private_flow_option = [
    {
      value: '',
      label: translate('all')
    },
    {
      value: "false",
      label: translate('not')
    },
    {
      value: "true",
      label: translate('yes')
    }
  ] as any;
  const ticket_platform_option = [
    {
      value: '',
      label: translate('all_platform')
    },
    {
      value: "actiup",
      label: translate('actiup_platform')
    },
    {
      value: "partner",
      label: translate('partner_platform')
    }
  ] as any;

  const breadcrumbItems = [
    {
      label: translate('order-management'),
      href: ''
    },
  ];

  const TABLE_HEAD_ALL = [translate('no'), translate('order-code'), translate('buyer-email'), translate('buyer-phone'), translate('ticket-name'), translate('event-name'), translate('group-name'), translate('e-ticket'), translate('VAT'), translate('payment-method'), translate('order-status'), translate('order-created-at'), translate('order-successful-at'), translate('ticket_platform'), translate('action')];
  const TABLE_HEAD_SPORT = [translate('no'), translate('order-code'), translate('buyer-email'), translate('buyer-phone'), translate('ticket-name'), translate('event-name'), translate('group-name'), translate('VAT'), translate('payment-method'), translate('order-status'), translate('order-created-at'), translate('order-successful-at'), translate('ticket_platform'), translate('action')];
  const TABLE_HEAD_ATTRACTION = [translate('no'), translate('order-code'), translate('buyer-email'), translate('buyer-phone'), translate('ticket-name'), translate('event-name'), translate('e-ticket'), translate('VAT'), translate('payment-method'), translate('order-status'), translate('order-created-at'), translate('order-successful-at'), translate('ticket_platform'), translate('action')];

  const [searchParams] = useSearchParams();
  const paramsObject = Object.fromEntries([...searchParams]);
  const navigate = useNavigate();
  const [initParams, setInitParams] = useState(true);
  const [eventDefault, setEventDefault] = useState(null as any);
  const [orderTypeDefault, setOrderTypeDefault] = useState(null as any);
  const [paymentDefault, setPaymentDefault] = useState(null as any);
  const [orderStatusDefault, setOrderStatusDefault] = useState(null as any);
  const [VATDefault, setVATDefault] = useState(null as any);
  const [privateFlowDefault, setPrivateFlowDefault] = useState(null as any);
  const [TicketPlatformDefault, setTicketPlatformDefault] = useState(null as any);
  const [token, setToken] = useState('');

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  useEffect(() => {
    if (token !== '') {
      handleCheckShowPlatform();
    }
  }, [token]);

  const handleCheckShowPlatform = async () => {
    try {
      const result = await ApiService.get(`orders/whitelabel/existed`, token);

      if (result && result?.whitelabel_orders_existed) {
        setShowPlatform(true);
      }


    } catch (error: any) {
      // toast.error(error.message);
      console.log("Fetch check show platform failed:", error.message);
    }
  }

  useEffect(() => {
    if (initParams) {
      const keys = Object.keys(paramsObject);

      if (keys?.length > 0) {
        handleInitSearchValue();
      } else {
        setFilter(true);
        setInitParams(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams]);

  const handleInitSearchValue = () => {
    const filterTemp = _.cloneDeep(filterGroup);

    if (paramsObject.q && paramsObject.q !== '') {
      filterTemp.q = paramsObject.q;
    }

    if (paramsObject.event_id && paramsObject.event_id !== '') {
      filterTemp.event_id = paramsObject.event_id;
    }

    if (paramsObject.order_type && paramsObject.order_type !== '') {
      filterTemp.order_type = paramsObject.order_type;
    }

    if (paramsObject.payment_method && paramsObject.payment_method !== '') {
      filterTemp.payment_method = paramsObject.payment_method;
    }

    if (paramsObject.order_status && paramsObject.order_status !== '') {
      filterTemp.order_status = paramsObject.order_status;
    }

    if (paramsObject.is_vat && paramsObject.is_vat !== '') {
      filterTemp.is_vat = paramsObject.is_vat;
    }

    if (paramsObject.ticket_platform && paramsObject.ticket_platform !== '') {
      filterTemp.ticket_platform = paramsObject.ticket_platform;
    }

    if (paramsObject.is_private_flow && paramsObject.is_private_flow !== '') {
      filterTemp.is_private_flow = paramsObject.is_private_flow;
    }

    if (paramsObject.gte && paramsObject.gte !== '') {
      setApplyDate({
        start: paramsObject.gte,
        end: paramsObject.lte
      })
    }

    if (paramsObject.sc_from && paramsObject.sc_from !== '') {
      setPurchasedDate({
        start: paramsObject.sc_from,
        end: paramsObject.sc_to
      })
    }

    setFilterGroup(filterTemp);

    const intervalInit = setInterval(() => {
      setFilter(true);
      setInitParams(false);
      clearInterval(intervalInit);
    }, 1000);

  }

  useEffect(() => {
    handleUpdateRoute();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterGroup, applyDate, purchasedDate])

  const handleUpdateRoute = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set('q', filterGroup.q);
    newSearchParams.set('event_id', filterGroup.event_id);
    newSearchParams.set('order_type', filterGroup.order_type);
    newSearchParams.set('payment_method', filterGroup.payment_method);
    newSearchParams.set('order_status', filterGroup.order_status);
    newSearchParams.set('is_vat', filterGroup.is_vat);
    newSearchParams.set('gte', applyDate.start);
    newSearchParams.set('lte', applyDate.end);
    newSearchParams.set('sc_from', purchasedDate.start);
    newSearchParams.set('sc_to', purchasedDate.end);
    newSearchParams.set('ticket_platform', filterGroup.ticket_platform);
    newSearchParams.set('is_private_flow', filterGroup.is_private_flow);

    const newParamsObject = Object.fromEntries([...newSearchParams]);

    const keys = Object.keys(newParamsObject);
    let changeRoute = false;

    if (keys?.length > 0) {
      keys?.forEach((key: string) => {
        if (newParamsObject[key] !== '') {
          changeRoute = true;
        }
      });
    }

    if (changeRoute || !initParams) {
      navigate(`?${newSearchParams.toString()}`, { replace: true });
    }
  }

  useEffect(() => {
    if (eventList?.length > 0) {
      if (filterGroup.event_id !== '') {
        eventList.forEach((item: any) => {
          if (item.value === filterGroup.event_id) {
            setEventDefault(item);
          }
        })
      } else {
        setEventDefault(eventList[0]);
      }
    }
  }, [filterGroup, eventList]);

  useEffect(() => {
    if (orderType?.length > 0) {
      if (filterGroup.order_type !== '') {
        orderType.forEach((item: any) => {
          if (item.value === filterGroup.order_type) {
            setOrderTypeDefault(item);
          }
        })
      } else {
        setOrderTypeDefault(orderType[0]);
      }
    }
  }, [filterGroup, orderType]);

  useEffect(() => {
    if (!initParams) {
      if (filterGroup.payment_method !== '') {
        payment_method.forEach((item: any) => {
          if (item.value === filterGroup.payment_method) {
            setPaymentDefault(item);
          }
        })
      } else {
        setPaymentDefault(payment_method[0]);
      }

      if (filterGroup.order_status !== '') {
        order_status.forEach((item: any) => {
          if (item.value === filterGroup.order_status) {
            setOrderStatusDefault(item);
          }
        })
      } else {
        setOrderStatusDefault(order_status[0])
      }

      if (filterGroup.is_vat !== '') {
        vat_option.forEach((item: any) => {
          if (item.value === filterGroup.is_vat) {
            setVATDefault(item);
          }
        })
      } else {
        setVATDefault(vat_option[0])
      }

      if (filterGroup.is_private_flow !== '') {
        private_flow_option.forEach((item: any) => {
          if (item.value === filterGroup.is_private_flow) {
            setPrivateFlowDefault(item);
          }
        })
      } else {
        setPrivateFlowDefault(private_flow_option[0])
      }

      if (filterGroup.ticket_platform !== '') {
        ticket_platform_option.forEach((item: any) => {
          if (item.value === filterGroup.ticket_platform) {
            setTicketPlatformDefault(item);
          }
        })
      } else {
        setTicketPlatformDefault(ticket_platform_option[0])
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterGroup, initParams]);

  useEffect(() => {
    if (token !== '') {
      const usr = localStorage.getItem('USER');

      if (usr) {
        const user_info = JSON.parse(usr);

        if (user_info.event_type && user_info.event_type.length > 0) {
          if (user_info.event_type.includes('sport')) {
            if (user_info.event_type.includes('attraction')) {
              setOrderType([
                {
                  value: '',
                  label: translate('all-order-type')
                },
                {
                  value: 'virtual_event',
                  label: translate('individual-ticket')
                },
                {
                  value: 'group_buy',
                  label: translate('group-ticket')
                },
                {
                  value: 'attraction',
                  label: translate('attraction')
                }
              ]);

              setAccountType("all");
            } else {
              setOrderType([
                {
                  value: '',
                  label: translate('all-order-type')
                },
                {
                  value: 'virtual_event',
                  label: translate('individual-ticket')
                },
                {
                  value: 'group_buy',
                  label: translate('group-ticket')
                }
              ]);

              setAccountType("sport");
            }
          } else {
            setAccountType('attraction');
          }
        }

        setFetchData(true);
      }
    }
  }, [token]);

  useEffect(() => {
    if (fetchData) {
      fetchEventList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const fetchEventList = async () => {
    // setLoading(true);
    try {
      const result = await ApiService.get(`events`, token);

      if (result) {
        const arr = [
          {
            value: '',
            label: translate('all')
          }
        ] as any;

        result.forEach((item: any) => {
          if (item.id !== 'all') {
            const obj = {
              value: item.id,
              label: get(item, `name_${language}`, '')
            };

            arr.push(obj);
          }

        });

        setEventList(arr);

        if (page === 0) {
          setPage(1);
        } else {
          setLoading(false);
        }
      }
    } catch (error: any) {
      // toast.error(error.message);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (page > 0 && filter) {
      fetchOrderList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const fetchOrderList = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`orders/page/${page}?q=${filterGroup.q}&gte=${applyDate.start}&lte=${applyDate.end}&sc_from=${purchasedDate.start}&sc_to=${purchasedDate.end}&payment_method=${filterGroup.payment_method}&order_status=${filterGroup.order_status}&order_type=${filterGroup.order_type}&event_id=${filterGroup.event_id}&is_vat=${filterGroup.is_vat}&ticket_platform=${filterGroup.ticket_platform}&is_private_flow=${filterGroup.is_private_flow }&limit=10`, token);

      if (result && result.orders) {
        setOrderList(result.orders);
        setPaging(result.paging);
        setLoading(false);
        setFilter(false);
      }
    } catch (error: any) {
      // toast.error(error.message);
      console.log("Fetch order list failed:", error.message);
      setLoading(false);
    }
  }

  const handleExportOrder = async (used_code: number) => {
    setLoading(true);

    const wsCurrency = localStorage.getItem('wsCurrency');

    const currentCurrency = (wsCurrency && wsCurrency !== '') ? wsCurrency : 'vnd';

    try {
      const result = await ApiService.get(`exports/order?q=${filterGroup.q}&gte=${applyDate.start}&lte=${applyDate.end}&sc_from=${purchasedDate.start}&sc_to=${purchasedDate.end}&payment_method=${filterGroup.payment_method}&order_status=${filterGroup.order_status}&order_type=${filterGroup.order_type}&event_id=${filterGroup.event_id}&is_vat=${filterGroup.is_vat}&is_used_code=${used_code}&currency=${currentCurrency}&ticket_platform=${filterGroup.ticket_platform}`, token);

      if (result) {
        toast.success(translate('export-success'));
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setLoading(false);

  }

  const handleUpdateFilter = (value: string, key: string) => {
    const dataFilter = { ...filterGroup } as any;

    dataFilter[key] = value;
    setFilterGroup({ ...dataFilter });
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      setFilter(true);
    }
  };

  const getValueSelect = (data: any, key: any) => {
    const dataFilter = { ...filterGroup } as any;
    const value = dataFilter[key];

    let res;
    data.forEach((item: any) => {
      if (item.value === value) {
        res = item;
      }
    });

    return res;
  }

  const getPaymentMethod = (method: string) => {
    const payment_method = method.toLowerCase();
    switch (payment_method) {
      case 'atm':
        return translate('atm');
      case 'bank_transfer':
        return translate('bank-transfer');
      case 'credit':
        return translate('credit');
      case 'partner_vnpay':
        return 'Partner VNPay';
      case 'vn_pay_b':
        return 'VNPAY';
      case 'vnpay':
        return 'QR Code';
      case 'zalopay':
        return 'ZaloPay';
      case 'viet_qr':
        return 'Viet QR';
      case 'momo':
        return translate('momo');
      case 'voucher':
        return translate('coupon');
      case 'shipcode':
        return 'Ship Code';
      case 'free':
        return translate('free-ticket');
      case 'bnpl':
        return translate('bnpl');
      case 'viettel_money':
        return translate('viettel_money');
      case 'v_atm':
        return translate('v_atm');
      case 'v_credit':
        return translate('v_credit');
      case 'payoo_atm':
        return translate('payoo_atm');
      case 'payoo_credit':
        return translate('payoo_credit');
      case 'onepay_viet_qr':
        return translate('onepay_viet_qr');
      case 'free_for_transfer':
        return translate('free-for-transfer');
      case 'stripe':
        return translate('stripe-payment');
      default:
        return method;
    }
  }

  if (!isMobile) {
    return (
      <div>
        <Breadcrumbs 
          type="wps"
          breadcrumbItems={breadcrumbItems}
          disableBorder={isMobile ? false : true}
          additionalLabel={(
            <div className="flex items-center justify-between mb-[10px]">
              <div className="w-[170px] h-11 rounded-[4px] border-[1px] border-[#A6A1FD] flex items-center justify-center cursor-pointer text-[#081774] btn-export-group mr-[20px]" onClick={() => handleExportOrder(1)}>
                <ArrowDownIcon className="w-[16px] h-[16px] mr-[5px]" />

                <div className="text-[14px]">{translate('export-used-code')}</div>
              </div>

              {/* <div className="w-[121px] h-[48px] rounded-[4px] border-[1px] border-[#081774] flex items-center justify-center cursor-pointer text-[#fff] btn-export-group mb-[10px] bg-[#081774]" onClick={() => handleExportOrder(0)}>
                <ArrowDownIcon className="w-[16px] h-[16px] mr-[5px]" />

                <div className="text-[14px]">{translate('export-order')}</div>
              </div> */}

              <NewButton onClick={() => handleExportOrder(0)} className="w-11 h-11 sm:w-auto">
                <ArrowDownIcon className="w-4 h-4 text-white" />{" "}
                <span className="hidden sm:block sm:ml-2">{translate('export-order')}</span>
              </NewButton>
            </div>
          )}
        />

        <div className="w-full p-[16px]" onKeyDown={handleKeyDown}>
          <div className="w-full bg-white p-[16px] rounded-[8px] flex flex-wrap gap-x-[12px] gap-y-[8px]">
            <div className="w-[calc(50%-6px)]">
              <div className="text-14 font-500 mb-[8px]">{translate('search')}</div>

              <input className="w-full h-[38px] text-14 border border-[#c5ccd2] rounded-[4px]"
                placeholder={translate('placeholder-search-orders')}
                value={filterGroup.q}
                onChange={(e: any) => handleUpdateFilter(e.target.value, 'q')} />
            </div>

            {
              eventList.length > 0 &&
              <div className="w-[calc(50%-6px)]">
                <div className="text-14 font-500 mb-[8px]">{translate('event-name')}</div>

                {
                  eventDefault &&
                  <Select
                    styles={{
                      input: (base) => ({
                        ...base,
                        "input:focus": {
                          boxShadow: "none",
                        },
                      })
                    }}
                    defaultValue={eventDefault}
                    name="events"
                    options={eventList}
                    className="filter-item__select"
                    classNamePrefix="select"
                    placeholder={eventList[0].label}
                    onChange={(e: any) => handleUpdateFilter(e.value, 'event_id')} />
                }

              </div>
            }

            {
              orderType.length > 0 &&
              <div className="w-[calc(25%-9px)]">
                <div className="text-14 font-500 mb-[8px]">{translate('order-type')}</div>

                {
                  orderTypeDefault &&
                  <Select
                    styles={{
                      input: (base) => ({
                        ...base,
                        "input:focus": {
                          boxShadow: "none",
                        },
                      })
                    }}
                    defaultValue={orderTypeDefault}
                    name="order-type"
                    options={orderType}
                    className="filter-item__select"
                    classNamePrefix="select"
                    placeholder={orderType[0].label}
                    onChange={(e: any) => handleUpdateFilter(e.value, 'order_type')} />
                }

              </div>
            }

            <div className="w-[calc(25%-9px)]">
              <div className="text-14 font-500 mb-[8px]">{translate('payment-method')}</div>

              {
                paymentDefault &&
                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  defaultValue={paymentDefault}
                  name="payment-method"
                  options={payment_method}
                  className="filter-item__select"
                  classNamePrefix="select"
                  placeholder={payment_method[0].label}
                  onChange={(e: any) => handleUpdateFilter(e.value, 'payment_method')} />
              }

            </div>

            <div className="w-[calc(25%-9px)]">
              <div className="text-14 font-500 mb-[8px]">{translate('order-status')}</div>

              {
                orderStatusDefault &&
                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  defaultValue={orderStatusDefault}
                  name="order-status"
                  options={order_status}
                  className="filter-item__select"
                  classNamePrefix="select"
                  placeholder={order_status[0].label}
                  onChange={(e: any) => handleUpdateFilter(e.value, 'order_status')} />
              }

            </div>

            <div className="w-[calc(25%-9px)]">
              <div className="text-14 font-500 mb-[8px]">VAT</div>

              {
                VATDefault &&
                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  defaultValue={VATDefault}
                  name="VAT"
                  options={vat_option}
                  className="filter-item__select"
                  classNamePrefix="select"
                  placeholder={vat_option[0].label}
                  onChange={(e: any) => handleUpdateFilter(e.value, 'is_vat')} />
              }

            </div>

            <div className="w-[calc(30%-12px)]">
              <div className="text-14 font-500 mb-[8px]">{translate('order-created-at')}</div>

              {
                !initParams &&
                <DateRangePicker
                  quickSelectDate={true}
                  isMobile={isMobile}
                  applyDate={applyDate}
                  setApplyDate={setApplyDate}
                />
              }

            </div>

            <div className="w-[calc(30%-12px)]">
              <div className="text-14 font-500 mb-[8px]">{translate('order-successful-at')}</div>

              {
                !initParams &&
                <DateRangePicker
                  quickSelectDate={true}
                  isMobile={isMobile}
                  applyDate={purchasedDate}
                  setApplyDate={setPurchasedDate}
                />
              }

            </div>

            {
              showPlatform &&
              <div className="w-[calc(30%-12px)]">
                <div className="text-14 font-500 mb-[8px]">{translate('ticket_platform')}</div>

                {
                  TicketPlatformDefault &&
                  <Select
                    styles={{
                      input: (base) => ({
                        ...base,
                        "input:focus": {
                          boxShadow: "none",
                        },
                      })
                    }}
                    defaultValue={TicketPlatformDefault}
                    name="ticket_platform"
                    options={ticket_platform_option}
                    className="filter-item__select"
                    classNamePrefix="select"
                    placeholder={ticket_platform_option[0].label}
                    onChange={(e: any) => handleUpdateFilter(e.value, 'ticket_platform')} />
                }

              </div>
            }

            <div className="w-[calc(25%-9px)]">
              <div className="text-14 font-500 mb-[8px]">{translate('private_flow')}</div>

              {
                privateFlowDefault &&
                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  defaultValue={privateFlowDefault}
                  name="is_private_flow"
                  options={private_flow_option}
                  className="filter-item__select"
                  classNamePrefix="select"
                  placeholder={private_flow_option[0].label}
                  onChange={(e: any) => handleUpdateFilter(e.value, 'is_private_flow')} />
              }

            </div>

            <Button
              placeholder="Button search coupon"
              className="w-[136px] h-[38px] border border-[#a6a1fd] text-14 text-brand-500 bg-white flex items-center justify-center mt-[30px]"
              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
              onResizeCapture={() => { }}
              onClick={() => {
                setFilter(true);
                setPage(1);
              }}>
              <SearchIcon className="w-4 h-4 icon-search" />
              <span>{translate('search')}</span>
            </Button>
          </div>

          <div className="w-full mt-[16px] rounded-[8px] p-[16px] bg-white">
            <div className="h-full w-full overflow-scroll overflow-y-hidden">
              <table className="w-full min-w-max table-auto text-left">
                <thead className="bg-[#e9ecff]">
                  {
                    accountType === 'all' &&
                    <tr>
                      {TABLE_HEAD_ALL.map((head) => {
                        return (
                          <th
                            key={head}
                            className={`p-4 ${((head === translate('ticket_platform')) && !showPlatform) && 'hidden'}`}
                          >
                            <Typography
                              variant="small"
                              className="!font-600 text-14"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {head}
                            </Typography>
                          </th>
                        )
                      })}
                    </tr>
                  }

                  {
                    accountType === 'sport' &&
                    <tr>
                      {TABLE_HEAD_SPORT.map((head) => (
                        <th
                          key={head}
                          className={`p-4 ${((head === translate('ticket_platform')) && !showPlatform) && 'hidden'}`}
                        >
                          <Typography
                            variant="small"
                            className="!font-600 text-14"
                            placeholder="Typography"
                            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                            onResizeCapture={() => { }}
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  }

                  {
                    accountType === 'attraction' &&
                    <tr>
                      {TABLE_HEAD_ATTRACTION.map((head) => (
                        <th
                          key={head}
                          className={`p-4 ${((head === translate('ticket_platform')) && !showPlatform) && 'hidden'}`}
                        >
                          <Typography
                            variant="small"
                            className="!font-600 text-14"
                            placeholder="Typography"
                            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                            onResizeCapture={() => { }}
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  }

                </thead>
                <tbody>
                  {
                    orderList.length > 0 &&
                    orderList.map((item: any, index: number) => {
                      const isLast = index === orderList.length - 1;
                      const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                      return (
                        <tr key={`event_${item.id}_${index}`} className="table-row">
                          <td className={classes}>
                            <Typography
                              variant="small"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {
                                index < 9 &&
                                <span>{paging.current_page - 1}{index + 1}</span>
                              }

                              {
                                index === 9 &&
                                <span>{paging.current_page}0</span>
                              }
                            </Typography>
                          </td>

                          <td className={classes}>
                            <a href={`/orders/${item.code}`}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="!font-600 cursor-pointer text-brand-500"
                                placeholder="Typography"
                                onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                onResizeCapture={() => { }}
                              >
                                {item.code}
                              </Typography>
                            </a>
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              {item.buyer_email}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              {item.buyer_phone}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              {get(item, `item_description_${language}`, '')}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                              className="w-[250px]"
                            >
                              {get(item, `event_name_${language}`, '')}
                            </Typography>
                          </td>

                          {
                            accountType !== 'attraction' &&
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                onResizeCapture={() => { }}
                                variant="small"
                                placeholder="Typography"
                              >
                                {item.group_name}
                              </Typography>
                            </td>
                          }

                          {
                            accountType !== 'sport' &&
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                onResizeCapture={() => { }}
                                variant="small"
                                placeholder="Typography"
                              >
                                {(item.ticket_use_for_date && item.ticket_use_for_date !== '') ? moment(item.ticket_use_for_date).format('DD/MM/YYYY HH:mm:ss') : ''}
                              </Typography>
                            </td>
                          }

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              <div className="flex-1 text-14">
                                {
                                  item.is_vat === 0 ?
                                    <span>{translate('not')}</span>
                                    :
                                    <span>{translate('yes')}</span>
                                }
                              </div>
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              {getPaymentMethod(item.payment_method)}
                            </Typography>
                          </td>

                          <td className={classes}>
                            {
                              item.order_status === 'doi_thanh_toan' &&
                              <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#7E22D7] bg-[#F3E8FF]">{translate('order-pending')}</div>
                            }

                            {
                              item.order_status === 'dat_hang_thanh_cong' &&
                              <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#1d813f] bg-[#dcfce7]">{translate('order-success')}</div>
                            }

                            {
                              item.order_status === 'da_huy' &&
                              <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#9D0520] bg-[#FFCFDD]">{translate('order-canceled')}</div>
                            }

                            {
                              item.order_status === 'hoan_tien' &&
                              <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#A16207] bg-[#FEF9C3]">{translate('order-refund')}</div>
                            }
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              {(item.created_at && item.created_at !== '') ? moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : ''}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              placeholder="Typography"
                            >
                              {(item.purchased_at && item.purchased_at !== '') ? moment(item.purchased_at).format('DD/MM/YYYY HH:mm:ss') : ''}
                            </Typography>
                          </td>

                          {
                            showPlatform &&
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                onResizeCapture={() => { }}
                                variant="small"
                                placeholder="Typography"
                              >
                                {(item.ticket_platform.includes('actiup')) ? translate('actiup_platform') : translate('partner_platform')}
                              </Typography>
                            </td>
                          }

                          {isHaveActionPermission(
                            "",
                            "orders",
                            "edit"
                          ) && (
                            <td className={classes}>
                              {item.order_status === "dat_hang_thanh_cong" && (
                                <a href={`/orders/${item.code}/edit`}>
                                  {/* <div className="w-[32px] h-[32px] rounded-[4px] bg-[#F5F6F7] flex items-center justify-center cursor-pointer">
                                  <img alt="icon-edit" src="/images/icons/icon-edit.svg" />
                                </div> */}

                                  <NewButton className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                                    <PencilIcon className="w-4 h-4 text-black" />
                                  </NewButton>
                                </a>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            {
              paging &&
              <div className="w-full mt-[16px] flex items-center justify-end">
                {
                  paging.total_page > 1 &&
                  <Pagination
                    setPage={setPage}
                    paging={paging}
                    setFilter={setFilter}
                    flex="end"
                  />
                }
              </div>
            }
          </div>

          {
            loading &&
            <FullScreenLoading />
          }
        </div>
      </div>
    )
  } else {
    return (
      <div className="coupon-form" onKeyDown={handleKeyDown}>
        <Breadcrumbs 
          type="wps"
          breadcrumbItems={breadcrumbItems}
          disableBorder={isMobile ? false : true}
          additionalLabel={(
            <div className="flex items-center">
              <Popover placement="bottom" open={openFilter} handler={setOpenFilter}>
                <PopoverHandler>
                  <SearchIcon className="w-5 h-5" />
                </PopoverHandler>
                <PopoverContent onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                  onResizeCapture={() => { }}
                  className="w-96 !left-[8px] grid grid-cols-1 gap-[16px]" placeholder="PopoverContent">
                  <div className="filter-item">
                    <div className="text-14 font-500 mb-[4px]">{translate('search')}</div>

                    <input type="text" className="w-full h-[38px] text-14 border border-[#c5ccd2] rounded-[4px]"
                      placeholder={translate('placeholder-search-orders-mobile')}
                      onChange={(e: any) => handleUpdateFilter(e.target.value, 'q')}
                      value={filterGroup.q} />
                  </div>
                  {
                    eventList.length > 0 &&
                    <div className="filter-item events">
                      <div className="text-14 font-500 mb-[4px]">{translate('event-name')}</div>

                      <Select
                        styles={{
                          input: (base) => ({
                            ...base,
                            "input:focus": {
                              boxShadow: "none",
                            },
                          })
                        }}
                        defaultValue={getValueSelect(eventList, 'event_id')}
                        name="events"
                        options={eventList}
                        className="filter-item__select"
                        classNamePrefix="select"
                        placeholder={eventList[0].label}
                        onChange={(e: any) => handleUpdateFilter(e.value, 'event_id')} />
                    </div>
                  }

                  {
                    orderType.length > 0 &&
                    <div className="filter-item order-type">
                      <div className="text-14 font-500 mb-[4px]">{translate('order-type')}</div>

                      <Select
                        styles={{
                          input: (base) => ({
                            ...base,
                            "input:focus": {
                              boxShadow: "none",
                            },
                          })
                        }}
                        defaultValue={getValueSelect(orderType, 'order_type')}
                        name="order-type"
                        options={orderType}
                        className="filter-item__select"
                        classNamePrefix="select"
                        placeholder={orderType[0].label}
                        onChange={(e: any) => handleUpdateFilter(e.value, 'order_type')} />
                    </div>
                  }

                  <div className="filter-item order-type">
                    <div className="text-14 font-500 mb-[4px]">{translate('payment-method')}</div>

                    <Select
                      styles={{
                        input: (base) => ({
                          ...base,
                          "input:focus": {
                            boxShadow: "none",
                          },
                        })
                      }}
                      defaultValue={getValueSelect(payment_method, 'payment_method')}
                      name="payment-method"
                      options={payment_method}
                      className="filter-item__select"
                      classNamePrefix="select"
                      placeholder={payment_method[0].label}
                      onChange={(e: any) => handleUpdateFilter(e.value, 'payment_method')} />
                  </div>

                  <div className="filter-item order-type">
                    <div className="text-14 font-500 mb-[4px]">{translate('order-status')}</div>

                    <Select
                      styles={{
                        input: (base) => ({
                          ...base,
                          "input:focus": {
                            boxShadow: "none",
                          },
                        })
                      }}
                      defaultValue={getValueSelect(order_status, 'order_status')}
                      name="order-status"
                      options={order_status}
                      className="filter-item__select"
                      classNamePrefix="select"
                      placeholder={order_status[0].label}
                      onChange={(e: any) => handleUpdateFilter(e.value, 'order_status')} />
                  </div>

                  <div className="filter-item order-type VAT">
                    <div className="text-14 font-500 mb-[4px]">VAT</div>

                    <Select
                      styles={{
                        input: (base) => ({
                          ...base,
                          "input:focus": {
                            boxShadow: "none",
                          },
                        })
                      }}
                      defaultValue={getValueSelect(vat_option, 'is_vat')}
                      name="VAT"
                      options={vat_option}
                      className="filter-item__select"
                      classNamePrefix="select"
                      placeholder={vat_option[0].label}
                      onChange={(e: any) => handleUpdateFilter(e.value, 'is_vat')} />
                  </div>

                  <div className="filter-item">
                    <div className="text-14 font-500 mb-[4px]">{translate('order-created-at')}</div>

                    <DateRangePicker
                      quickSelectDate={true}
                      isMobile={isMobile}
                      setApplyDate={setApplyDate}
                      applyDate={applyDate}
                    />
                  </div>

                  <div className="filter-item">
                    <div className="text-14 font-500 mb-[4px]">{translate('order-successful-at')}</div>

                    <DateRangePicker
                      quickSelectDate={true}
                      isMobile={isMobile}
                      setApplyDate={setPurchasedDate}
                      applyDate={purchasedDate}
                    />
                  </div>

                  {
                    showPlatform &&
                    <div className="filter-item order-type">
                      <div className="text-14 font-500 mb-[4px]">{translate('ticket_platform')}</div>

                      <Select
                        styles={{
                          input: (base) => ({
                            ...base,
                            "input:focus": {
                              boxShadow: "none",
                            },
                          })
                        }}
                        defaultValue={getValueSelect(ticket_platform_option, 'ticket_platform')}
                        name="ticket_platform_option"
                        options={ticket_platform_option}
                        className="filter-item__select"
                        classNamePrefix="select"
                        placeholder={ticket_platform_option[0].label}
                        onChange={(e: any) => handleUpdateFilter(e.value, 'ticket_platform')} />
                    </div>
                  }

                  <div className="filter-item order-type VAT">
                    <div className="text-14 font-500 mb-[4px]">{translate('private_flow')}</div>

                    {
                      privateFlowDefault &&
                      <Select
                        styles={{
                          input: (base) => ({
                            ...base,
                            "input:focus": {
                              boxShadow: "none",
                            },
                          })
                        }}
                        defaultValue={privateFlowDefault}
                        name="is_private_flow"
                        options={private_flow_option}
                        className="filter-item__select"
                        classNamePrefix="select"
                        placeholder={private_flow_option[0].label}
                        onChange={(e: any) => handleUpdateFilter(e.value, 'is_private_flow')} />
                    }
                  </div>

                  {/* <Button
                    placeholder="Button search coupon"
                    className="w-full h-[40px] flex items-center justify-center border border-[#a6a1fd] text-[#a6a1fd] text-brand-500"
                    onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                    onResizeCapture={() => { }}
                    onClick={() => {
                      setFilter(true);
                      setOpenFilter(false);
                      setPage(1);
                    }}>
                    <SearchIcon className="w-4 h-4 icon-search" />
                    <span>{translate('search')}</span>
                  </Button> */}

                  <NewButton
                    className="w-auto bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85"
                    onClick={() => {
                      setFilter(true);
                      setOpenFilter(false);
                      setPage(1);
                    }}
                  >
                    <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> {translate('search')}
                  </NewButton>

                  <div className="w-[100%] h-[38px] rounded-[4px] border-[1px] border-[#A6A1FD] flex items-center justify-center cursor-pointer text-[#081774] btn-export-group" onClick={() => handleExportOrder(0)}>
                    <ArrowDownIcon className="w-[16px] h-[16px] mr-[5px]" />

                    <div className="text-[14px]">{translate('export-report')}</div>
                  </div>
                </PopoverContent>
              </Popover>

              <Popover placement="bottom" open={openExportGroup} handler={setOpenExportGroup}>
                <PopoverHandler>
                  <img src="/images/icons/icon-dots.svg" className="cursor-pointer ml-[10px]" alt="icon-export-group" />
                </PopoverHandler>

                <PopoverContent onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                  onResizeCapture={() => { }}
                  className="w-96 !left-[8px]" placeholder="PopoverContent">
                  <div className="w-[100%] h-[48px] rounded-[4px] border-[1px] border-[#A6A1FD] flex items-center justify-center cursor-pointer text-[#081774] btn-export-group mb-[10px]" onClick={() => handleExportOrder(1)}>
                    <ArrowDownIcon className="w-[16px] h-[16px] mr-[5px]" />

                    <div className="text-[14px]">{translate('export-used-code')}</div>
                  </div>

                  {/* <div className="w-[100%] h-[48px] rounded-[4px] border-[1px] border-[#081774] flex items-center justify-center cursor-pointer text-[#fff] btn-export-group mt-[10px] bg-[#081774]" onClick={() => handleExportOrder(1)}>
                    <ArrowDownIcon className="w-[16px] h-[16px] mr-[5px]" />

                    <div className="text-[14px]">{translate('export-order')}</div>
                  </div> */}

                  <NewButton onClick={() => handleExportOrder(1)} className="w-full h-11 sm:w-auto">
                    <ArrowDownIcon className="w-4 h-4 text-white" />{" "}
                    <span className="ml-2">{translate('export-order')}</span>
                  </NewButton>
                </PopoverContent>
              </Popover>
            </div>
          )}
        />

        <div className={openFilter ? "coupon-form__body overlay p-[16px] grid grid-cols-1 gap-[8px]" : "coupon-form__body p-[16px] grid grid-cols-1 gap-[8px]"}>
          {
            orderList.map((item: any, index: number) => {
              return (
                <div className="w-full p-[16px] bg-white rounded-[8px] grid grid-cols-1 gap-[8px]" key={`coupon-item-${index}`}>
                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('action')}</div>

                    <div className="flex items-center w-[100%] justify-end">
                      {/* <div className="w-[32px] h-[32px] flex items-center justify-center bg-[#F5F6F7] rounded-[4px]" onClick={() => {
                        window.location.href = `/orders/${item.code}`
                      }}>
                        <EyeIcon className="w-[20px] h-[20px] text-[#262626]" />
                      </div> */}

                      <NewButton
                        className="w-[32px] h-[32px] ml-[12px] bg-gray-200 hover:bg-gray-100 active:bg-gray-300"
                        onClick={() => {
                          window.location.href = `/orders/${item.code}`
                        }}
                      >
                        <EyeIcon className="w-4 h-4 text-black" />
                      </NewButton>

                      {item.order_status === "dat_hang_thanh_cong" &&
                      isHaveActionPermission("", "orders", "edit") && (
                        <>
                          {/* <div className="w-[32px] h-[32px] flex items-center justify-center bg-[#F5F6F7] rounded-[4px] ml-[12px]" onClick={() => {
                          window.location.href = `/orders/${item.code}/edit`
                          }}>
                            <img src="/images/icons/icon-edit.svg" alt="icon-edit" />                          
                          </div> */}

                          <NewButton
                            className="w-[32px] h-[32px] ml-[12px] bg-gray-200 hover:bg-gray-100 active:bg-gray-300"
                            onClick={() => {
                              window.location.href = `/orders/${item.code}/edit`;
                            }}
                          >
                            <PencilIcon className="w-4 h-4 text-black" />
                          </NewButton>
                        </>
                      )}

                    </div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('status')}</div>

                    {
                      item.order_status === 'doi_thanh_toan' &&
                      <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#7E22D7] bg-[#F3E8FF]">{translate('order-pending')}</div>
                    }

                    {
                      item.order_status === 'dat_hang_thanh_cong' &&
                      <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#1d813f] bg-[#dcfce7]">{translate('order-success')}</div>
                    }

                    {
                      item.order_status === 'da_huy' &&
                      <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#9D0520] bg-[#FFCFDD]">{translate('order-canceled')}</div>
                    }

                    {
                      item.order_status === 'hoan_tien' &&
                      <div className="text-12 rounded-[16px] !font-500 px-[16px] py-[5px] text-center text-[#A16207] bg-[#FEF9C3]">{translate('order-refund')}</div>
                    }
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('no')}</div>
                    <div className="flex-1 text-14">{
                      index < 9 &&
                      <span>{paging.current_page - 1}{index + 1}</span>
                    }

                      {
                        index === 9 &&
                        <span>{paging.current_page}0</span>
                      }</div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('order-code')}</div>
                    <div className="flex-1 text-14">{item.code}</div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('buyer-email')}</div>
                    <div className="flex-1 text-14">{item.buyer_email}</div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('buyer-phone')}</div>
                    <div className="flex-1 text-14">{item.buyer_phone}</div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('ticket-name')}</div>
                    <div className="flex-1 text-14">{get(item, `item_description_${language}`, '')}</div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('event-name')}</div>
                    <div className="flex-1 text-14">{get(item, `event_name_${language}`, '')}</div>
                  </div>

                  {
                    accountType !== 'attraction' &&
                    <div className="flex items-start gap-[8px]">
                      <div className="w-[112px] text-14 font-500">{translate('group-name')}</div>
                      <div className="flex-1 text-14">{item.group_name}</div>
                    </div>
                  }

                  {
                    accountType !== 'sport' &&
                    <div className="flex items-start gap-[8px]">
                      <div className="w-[112px] text-14 font-500">{translate('e-ticket')}</div>
                      <div className="flex-1 text-14">
                        {(item.ticket_use_for_date && item.ticket_use_for_date !== '') ? moment(item.ticket_use_for_date).format('DD/MM/YYYY HH:mm:ss') : ''}
                      </div>
                    </div>
                  }

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('VAT')}</div>
                    <div className="flex-1 text-14">
                      {
                        item.is_vat === 0 ?
                          <span>{translate('not')}</span>
                          :
                          <span>{translate('yes')}</span>
                      }
                    </div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('payment-method')}</div>
                    <div className="flex-1 text-14">{getPaymentMethod(item.payment_method)}</div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('order-created-at')}</div>
                    <div className="flex-1 text-14">
                      {(item.created_at && item.created_at !== '') ? moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : ''}
                    </div>
                  </div>

                  <div className="flex items-start gap-[8px]">
                    <div className="w-[112px] text-14 font-500">{translate('order-successful-at')}</div>
                    <div className="flex-1 text-14">
                      {(item.purchased_at && item.purchased_at !== '') ? moment(item.purchased_at).format('DD/MM/YYYY HH:mm:ss') : ''}
                    </div>
                  </div>

                  {
                    showPlatform &&
                    <div className="flex items-start gap-[8px]">
                      <div className="w-[112px] text-14 font-500">{translate('ticket_platform')}</div>
                      <div className="flex-1 text-14">
                        {(item.ticket_platform.includes('actiup')) ? translate('actiup_platform') : translate('partner_platform')}
                      </div>
                    </div>
                  }

                </div>
              )
            })
          }

          {
            paging &&
            <div className="board__bottom">
              {
                paging.total_page > 1 &&
                <Pagination
                  setPage={setPage}
                  paging={paging}
                  setFilter={setFilter}
                />
              }
            </div>
          }
        </div>

        {
          loading &&
          <FullScreenLoading />
        }
      </div>
    )
  }

}

const WPSOrders = () => {
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);
  const { translate, getLocale } = useTranslation();
  const language = getLocale();

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);


  return (
    <div className="w-full">
      <div className='w-full'>
        <OrdersForm
          isMobile={isMobile}
          translate={translate}
          language={language} />
      </div>

    </div>
  )
}

export default WPSOrders;